import { motion } from 'framer-motion';
import { useState } from 'react';
import Button from '../UI/Button';

const goals = [
  {
    id: 'energy',
    title: 'More Energy',
    description: 'Wake up refreshed and maintain energy throughout the day'
  },
  {
    id: 'clarity',
    title: 'Mental Clarity',
    description: 'Sharper focus and improved cognitive performance'
  },
  {
    id: 'recovery',
    title: 'Better Recovery',
    description: 'Bounce back faster from workouts and daily stress'
  },
  {
    id: 'aging',
    title: 'Healthy Aging',
    description: 'Feel younger and maintain vitality as you age'
  },
  {
    id: 'sleep',
    title: 'Better Sleep',
    description: 'Fall asleep easier and wake up more rested'
  },
  {
    id: 'mood',
    title: 'Enhanced Mood',
    description: 'Feel more positive and emotionally balanced'
  }
];

export default function GoalsScreen({ onContinue }) {
  const [selectedGoals, setSelectedGoals] = useState([]);

  const toggleGoal = (goalId) => {
    setSelectedGoals(prev =>
      prev.includes(goalId)
        ? prev.filter(id => id !== goalId)
        : [...prev, goalId]
    );
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-2xl mx-auto"
    >
      <div className="bg-white rounded-luxury shadow-luxury p-8">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal text-center mb-4">
            What would you <span className="text-renuvia-gold">love to achieve</span>?
          </h2>

          <p className="text-slate text-center mb-8 text-lg">
            Select all that apply to personalize your experience.
          </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8">
          {goals.map((goal, index) => (
            <motion.button
              key={goal.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              onClick={() => toggleGoal(goal.id)}
              className={`p-4 rounded-xl border-2 transition-all text-left relative ${
                selectedGoals.includes(goal.id)
                  ? 'border-renuvia-gold bg-renuvia-gold bg-opacity-5'
                  : 'border-gray-200 hover:border-renuvia-gold hover:bg-warm-beige'
              }`}
            >
              <div className="flex items-start gap-3">
                {/* Checkbox */}
                <div className={`flex-shrink-0 w-5 h-5 mt-0.5 rounded border-2 flex items-center justify-center ${
                  selectedGoals.includes(goal.id)
                    ? 'border-renuvia-gold bg-renuvia-gold'
                    : 'border-gray-300'
                }`}>
                  {selectedGoals.includes(goal.id) && (
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>

                <div className="flex-1">
                  <h3 className="font-semibold text-charcoal mb-1 text-base">
                    {goal.title}
                  </h3>
                  <p className="text-slate text-sm leading-relaxed">
                    {goal.description}
                  </p>
                </div>
              </div>
            </motion.button>
          ))}
        </div>

        <Button
          onClick={onContinue}
          fullWidth
          disabled={selectedGoals.length === 0}
        >
          Continue →
        </Button>
      </div>
    </motion.div>
  );
}
